import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createRoot } from 'react-dom/client';
import classes from './classes.module.scss';
import { WizardSteps } from '../../utils/enums';
import ScrollableBackgroundLayer from './scrollable_background_layer';

function Layout({ children, step }) {
  const [portalContainer] = useState(() => document.createElement('div'));
  const [backgroundScrollPosition, setBackgroundScrollPosition] = useState(0);

  const rootRef = useRef();

  const renderBackgroundPortal = () => (
    <div className={ classes.absoluteBackground } />
  );

  useEffect(() => {
    let isUnmounted = false;

    document.body.appendChild(portalContainer);
    const backgroundPortal = renderBackgroundPortal();
    if (!rootRef.current) {
      rootRef.current = createRoot(portalContainer);
    }
    rootRef.current.render(backgroundPortal);

    return () => {
      if (portalContainer.parentNode) {
        portalContainer.parentNode.removeChild(portalContainer);
      }

      if (rootRef.current) {
        isUnmounted = true;

        setTimeout(() => {
          if (!isUnmounted) {
            rootRef.current.unmount();
          }
        }, 0);
      }
    };
  }, []);

  useEffect(() => {
    if (step <= WizardSteps.AboutMe) {
      setBackgroundScrollPosition(0);
    } else if (step >= WizardSteps.WhatsNext) {
      setBackgroundScrollPosition(100);
    } else {
      const scrollPercentage = (step / WizardSteps.WhatsNext) * 100;
      setBackgroundScrollPosition(scrollPercentage);
    }
  }, [step]);

  const renderLayout = () => (
    <>
      <div className={ classes.backgroundLayer }>
        <ScrollableBackgroundLayer
          className={ classnames(classes.backgroundLayer, classes.backgroundLayer2) }
          scrollTo={ backgroundScrollPosition }
        />
        <ScrollableBackgroundLayer
          className={ classnames(classes.backgroundLayer, classes.backgroundLayer3) }
          scrollTo={ backgroundScrollPosition }
        />
      </div>
      <div className={ classes.contentContainer }>
        <div className={ classes.content }>
          {children}

        </div>
      </div>
    </>
  );

  return renderLayout();
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  step: PropTypes.number
};

Layout.defaultProps = {
  step: 0
};

export default Layout;
